import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { instanceAPIPrivate } from 'config/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const offerNow = createAsyncThunk(
  'offer',
  async (offerValue) => {
    const offer = await instanceAPIPrivate.post('/make-offer', offerValue, axiosConfig)
      .then((resp) => resp.data)
      .catch((err) => err.response.data);
    return offer;
  },
);

const offerSlice = createSlice({
  name: 'offer',
  initialState: {
    offer: {},
    statusOffer: '',
    offerAgain: true,
  },
  extraReducers: {
    [offerNow.pending]: (state) => {
      state.statusOffer = 'loading';
    },
    [offerNow.fulfilled]: (state, action) => {
      state.statusOffer = 'success';
      state.offer = action.payload;
    },
    [offerNow.rejected]: (state) => {
      state.statusOffer = 'failed';
    },
  },
  reducers: {
    resetOffer: (state) => {
      state.offer = {};
      state.statusOffer = '';
    },
    changeOfferAgain: (state) => {
      state.offerAgain = !state.offerAgain;
    },
  },
});

export const { resetOffer, changeOfferAgain } = offerSlice.actions;
export default offerSlice.reducer;
